export default __webpack_public_path__ + "static/media/venus-bg-effect-2.04cf1154.svg";